import React, { Component } from 'react';
import { connect } from 'react-redux';
// import { changepayInfoData.CurrentIndex ,changepayInfoData.CurrentType} from '../../../action/productAction';
import Util from '../../../util';
import { hashHistory } from 'react-router';
import NavigatorMain from '../../NavigatorMain';
import {bankCode} from '../../../BankCode';
import ModalSelectTip from '../../Modal/ModalSelectTip';
import { myAddPhoneText,myAddCardText} from '../../../action/publicAction';
import ModalList from '../../Modal/ModalList';
import { hqtXz } from "../../../action/investmentAction"

class PayCardList extends Component {
  constructor(props) {  
    super(props); 
    this.state = {
      unUseBank:false,
      unUseBankTip:'',
      alertFlag:false
    } 
  } 
  componentWillMount() {
    document.title = "选择支付方式"
    if(this.props.location.state && this.props.location.state.callback){
      this.props.location.state.callback()
    }
  }
  choseBank(item,i){
    console.log(item)
    if(item.bankAccountShowNo2){
      this.setState({
        alertFlag:true,
        alertContent:`由于您在华夏基金的${item.bankName}（*${item.bankAccountShowNo.slice(-4)}）与华夏财富的${item.bankName}（*${item.bankAccountShowNo2.slice(-4)}）信息不一致，该渠道活期通份额暂不可用。如需银行卡信息变更，请您分别在华夏基金官网和华夏财富官网进行变更。如有疑问，请咨询客服热线400-817-5666。`
      })
      return
    }else if(item.trustChannelDisplayName == "招商银行在线支付") {
      if(item.ywt == false) {
        this.setState({
          alertFlag:true,
          alertContent:"您的银行卡未签约，请登录华夏基金官网【银行卡管理-代扣签约】进行签约升级或咨询投资顾问。客服电话：400-817-5666"
        })
        return
      }else if(item.ywt == null) {
        if(item.enableCMBTrustChannel === false){
          this.setState({
            alertFlag:true,
            alertContent:"为确保资金同卡进出的原则，请补充该招商银行卡信息，该渠道活期通份额方可在华夏财富使用。您可以直接登录华夏财富官网个人中心提交银行卡信息，或致电客服热线400-817-5666进行办理。"
          })
          return
        }
      }
    }
    let { dispatch,payInfoData } = this.props;
    Object.assign(payInfoData,{currentType:2},{currentIndex:i})
    this.props.dispatch(hqtXz(item.bankCode))
    dispatch({
      type:this.props.location.state.actionType+"_PAY_INFO",
      text:payInfoData
    });
    hashHistory.goBack()
  }
  JumpAddCard(){
    console.log('加卡');
    hashHistory.push({
     pathname:'/HqtAddCard',
     state:{
        isShow:true,
        callback:this.props.location.state.callback
     } 
    })
  }
  closeMoadl = ()=>{
    this.setState({
      alertFlag:false
    })
  }
  render(){
    const { 
      payInfoData,
      currentIndex,
      currentType
    }=this.props;

    let icon=[require('../../../img/circleHookG.png'),require('../../../img/circleHookO.png')];
    console.log(payInfoData,"payInfoDatapayInfoDatapayInfoData")
    return (
        <div className="container" >
          <NavigatorMain>
            <div className="header black">
              <div onClick={hashHistory.goBack}><span className="headerLeftBtn"></span></div>
              <div>选择支付方式</div>
              <div></div>
            </div>
          </NavigatorMain>
          <div className='content' >
            <div className='bankTypeName'>银行卡支付</div>
          {
            payInfoData.content.currentAccountList.map( (item,i)=> {
              return(
                <div key={`current${i}`} className='bankList' onClick={()=>this.choseBank(item,i)} style={item.trustChannelDisplayName == "招商银行在线支付" && item.ywt == null ? item.enableCMBTrustChannel === "0" ? {backgroundColor:"rgba(0, 0, 0, 0.1)"} : {} : {}}>
                  <img src={ bankCode['ty'][item.bankCode]?bankCode['ty'][item.bankCode]:require('../../../img/bank.png')} className='img'/>
                  <div className='bankListTip' >
                    <p>{Util.formatStr(item.bankName)+'(*'+Util.formatStr(item.bankAccountShowNo).substr(-4)+')'}
                    { 
                      item.trustChannelDisplayName == "招商银行在线支付" && item.ywt == null ?
                      item.enableCMBTrustChannel === "0" ? 
                      <span style={{color:'rgb(104,113,126)',fontSize:12,padding:2,backgroundColor:"rgba(0,0,0,0.1)",justifyContent:"center",marginLeft:"5px"}}>不可用</span>
                      : 
                      null
                      :
                      null
                    }
                    </p>
                    {
                      item.trustChannelDisplayName == "招商银行在线支付" && item.ywt == false ?
                      <p>招行卡暂不可用，请您去华夏基金管家App操作或咨询客服</p>
                      :
                      <p>{window.funSplit(item.tradeMaxAmountTips)[1]}</p>
                    }
            
                  </div>
                  <div className='bankListRightOK'>
                    <img src={payInfoData.currentType===2&&item.bankCode==this.props.hqtXz?icon[1]:icon[0]} className='img'/>
                  </div>
                </div>
              )
            })
          }
            <div className='btnAddCard' onClick={()=>{this.JumpAddCard() }}>
              <span style={{color:'#000', fontSize:'15px'}}>+添加银行卡</span>
            </div>
          </div>
          <ModalSelectTip onCancel={()=>{this.setState({unUseBank:false})}} onOK={()=>{this.setState({unUseBank:false})}} flag={this.state.unUseBank} height={240} title = '银行渠道提示' content = {this.state.unUseConent}   />
          <ModalList flag={this.state.alertFlag} btnRight={"确认"} btnRightFun={this.closeMoadl} content={this.state.alertContent} title={"温馨提示"} />
        </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
  console.log(ownProps.location.state.type+'PayInfo');
  return {
    // payInfoData:state[ownProps.location.state.type+'PayInfo'],
    payInfoData:state.hqtPayInfo,
    hqtXz:state.hqtXz
  }
}
export default connect(mapStateToProps)(PayCardList);



// WEBPACK FOOTER //
// ./src/components/myAssets/payment/HqtCardList.js